import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const AdminSelectionPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleAdminPanel = () => {
    navigate("/admin");
  };

  const handleCoursesPanel = () => {
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 flex items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-8 text-center">
            <div className="flex justify-center mb-6">
              <img
                src="https://giro-logos.s3.us-east-1.amazonaws.com/public/logo-branco.png"
                alt="Giro.Tech"
                className="h-20 w-auto"
              />
            </div>
            <h1 className="text-white text-3xl font-bold mb-2">Painel Administrativo</h1>
            <p className="text-blue-100 text-lg">
              Bem-vindo, {user?.name}! Escolha o painel que deseja acessar.
            </p>
          </div>

          {/* Cards */}
          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Painel Admin */}
              <div
                onClick={handleAdminPanel}
                className="bg-gradient-to-br from-red-50 to-red-100 border-2 border-red-200 rounded-xl p-6 cursor-pointer hover:shadow-lg hover:border-red-300 transition-all duration-200 group"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center mr-4">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">Painel Admin</h3>
                </div>
                <p className="text-gray-600 mb-4">
                  Gerencie usuários, cursos, grupos e configurações administrativas da plataforma.
                </p>
                <div className="flex items-center text-red-600 font-medium group-hover:text-red-700">
                  <span>Acessar Painel Admin</span>
                  <svg
                    className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>

              {/* Painel de Cursos */}
              <div
                onClick={handleCoursesPanel}
                className="bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-200 rounded-xl p-6 cursor-pointer hover:shadow-lg hover:border-blue-300 transition-all duration-200 group"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mr-4">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">Painel de Cursos</h3>
                </div>
                <p className="text-gray-600 mb-4">
                  Acesse os cursos como um usuário normal, visualize o progresso e gerencie seu
                  aprendizado.
                </p>
                <div className="flex items-center text-blue-600 font-medium group-hover:text-blue-700">
                  <span>Acessar Cursos</span>
                  <svg
                    className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="mt-8 text-center">
              <p className="text-gray-500 text-sm">
                Como administrador, você tem acesso a ambos os painéis
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSelectionPage;
